/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DeleteConfirmationModal {
  @Input() elementName: string = '';
  @Input() element: string = '';
  @Input() isJustChangeConfirmation? = false;
  @Input() isDeleteConfirmation? = true;
  @Input() isDeleteConfirm? = false;
  @Input() isGdprDeleteConfirm? = false;
  @Input() isArchiveConfirmation? = false;
  @Input() isOrgUnitDeleteConfirmation? = false;
  @Input() isTerminateProgramConfirmation? = false;
  @Input() elementId?: any;
  @Input() isNote?: boolean = false;
  @Input() isCancelProgramConfirmation? = false;

  public onClose: Subject<any>;

  constructor(public bsModalRef: BsModalRef, private commonService: CommonService) {
    this.onClose = new Subject();
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.onClose.next('closed');
    this.bsModalRef.hide();
  }

  public confirmChange() {
    this.onClose.next('confirmed');
    this.bsModalRef.hide();
  }
}
